import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useState } from "react";
import { searchByProp } from "utils/search";
import FolderDetail from "./FolderDetail";

const FETCH_ONE_DRIVE_FOLDER = gql`
  query FETCH_ONE_DRIVE_PRODUCTS {
    oneDriveChildren(path: "wis/beautyshots/wis")
  }
`;

const WisBeautyshots = ({ id }) => {
  const { loading, error, data } = useQuery(FETCH_ONE_DRIVE_FOLDER, {
    variables: { id },
  });
  const [searchText, setSearchText] = useState("");
  const modal = useModals();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.oneDriveChildren).value;

  const products = res.filter((i) => searchByProp(i, ["name"], searchText));

  return (
    <div>
      <div className="p-6">
        <SearchBar
          placeholder="Search by name"
          text={searchText}
          onChange={setSearchText}
        />
        <div className="flex gap-2 mt-2 text-xs opacity-70">
          <span>SharePoint:</span>
          <a
            href="https://wabobaadmin.sharepoint.com/sites/Waboba/Shared%20Documents/wis/beautyshots/wis/"
            target="_blank"
          >
            Waboba / Documents / wis / beautyshots / wis
          </a>
        </div>
      </div>
      <div>
        {products.map((i) => (
          <div
            key={i.id}
            className="py-2 px-6 border dark:border-gray-700 cursor-pointer hover:bg-gray-100 dark:bg-gray-700"
            onClick={() =>
              modal.present({
                title: "WIS Images from SharePoint",
                maxWidth: "max-w-7xl",
                children: <FolderDetail id={i.id} slug={i.name}></FolderDetail>,
              })
            }
          >
            <div>
              {i.name} ({i.folder ? i.folder.childCount : 0})
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WisBeautyshots;
